














import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';

@Component({
    components: {
        ConfirmDialog
    }
})

class DeleteFilterView extends Vue {
    @Prop() filter;

    deleteDialog = false;

    deleteView() {
        this.deleteDialog = false;
        this.$emit('delete');
    }

}

export default DeleteFilterView;
